import React, { useContext } from 'react';
import styles from "./Chatbot.module.scss";
import { Button } from "@mui/material";
import { ChatContext } from './Context';

const ChatFooter: React.FC = () => {
    const { inputText, setInputText, handleSendButtonClick } = useContext(ChatContext);

    const handleInputChange = (event: any) => {
        setInputText(event.target.value);
    };

    const handleEnterKeyPress = (event: { key: string }) => {
        if (event.key === "Enter") {
            handleSendButtonClick();
        }
    };

    return (
        <div className={styles.chatbox__footer}>
            <input
                style={{ outline: "none" }}
                type="text"
                placeholder="Write a message..."
                value={inputText}
                onChange={handleInputChange}
                onKeyDown={handleEnterKeyPress}
            />
            <Button
                variant="containedSmall"
                className={`${styles.chatbox__send__footer} ${styles.send__button}`}
                onClick={handleSendButtonClick}
            >
                Send
            </Button>
        </div>
    );
};

export default ChatFooter;